import clsx from 'clsx'
import { ReactNode } from 'react'
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'

export const FormSearchTable = ({
  label,
  children,
  className,
  error,
  helperText,
  errorStyle,
  required = false,
}: {
  label: string
  children: ReactNode
  className?: string
  errorStyle?: string
  error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>
  helperText?: string
  required?: boolean
}) => {
  return (
    <div className={clsx('flex items-stretch lg:gap-2 mt-20 flex-wrap lg:flex-nowrap', className)}>
      <div className="lg:min-w-[250px] lg:w-[250px] w-full lg:bg-[#C3C3C3] flex items-center justify-between px-2 lg:px-5 flex-shrink-0 ">
        <p className="text-base text-[#5D5D5D] font-bold">{label}</p>
        {required && <p className="text-xs text-[#FF0000] whitespace-nowrap text-right">＊必須</p>}
      </div>
      <div className="bg-[#ECECEC] flex-1">
        <div className="px-[10px] py-5">
          {children}
          {!!error && (
            <div className={`text-left mt-2 ${errorStyle ?? 'text-xs text-[#ff0909]'}`}>{error as string}</div>
          )}
          {!!helperText && (
            <div className={`text-left mt-2 ${errorStyle ?? 'text-xs text-primary'}`}>{helperText as string}</div>
          )}
        </div>
      </div>
    </div>
  )
}
